export const toHexStr = (num: number): string => {
  return `0x${num.toString(16)}`
}
